<ng-container *ngIf="!this.oneButton">
	<div #actualTarget>
		<button [class]="styleClass" (click)="getAvailableActions($event);menu.toggle($event);" appNoDblClick
			[disabled]="isDisabled" type="button">
			<i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
		</button>
		<p-menu #menu [model]="this.options" [popup]="true" appendTo="body" (onClick)="reloadEvent()"></p-menu>
	</div>
</ng-container>
<ng-container *ngIf="this.oneButton">
	<button appNoDblClick class="btn btn-sm btn-secondary m-l-lg unlock-float-btn" (click)="executeButtonCommand()"
		type="button">
		<i class="{{ this.actionButton.icon}}"></i> {{this.actionButton.label}}</button>
</ng-container>